import { Button } from "@mui/material";
import { useModalState } from "@src/lib/ui-react";

import { RequirementMappingDialog } from "./RequirementMappingDialog";
import { type RequirementMapping } from "./types";

interface EditRequirementMappingDialogProps {
  hcfId?: string;
  requirementMapping: RequirementMapping;
  onSuccess: () => void;
}

export function EditRequirementMappingDialog(props: EditRequirementMappingDialogProps) {
  const { hcfId, requirementMapping, onSuccess } = props;
  const modalState = useModalState();

  return (
    <>
      <Button onClick={modalState.openModal}>Edit</Button>
      {modalState.modalIsOpen && (
        <RequirementMappingDialog
          modalState={modalState}
          hcfId={hcfId}
          requirementMapping={requirementMapping}
          title="Edit Requirement Mapping"
          onSuccess={onSuccess}
        />
      )}
    </>
  );
}
